// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as FareEstimateReqRadioGroupCmp$PorterinFeature from "./FareEstimateReqRadioGroupCmp.mjs";
import * as FareEstimateRequirementModuleScss from "../styles/FareEstimateRequirement.module.scss";

var styles = FareEstimateRequirementModuleScss;

function FareEstimateSelectReqCmp(Props) {
  var requirement = Props.requirement;
  var onChange = Props.onChange;
  var disabled = Props.disabled;
  var label = Props.label;
  var is_required = Props.is_required;
  var error = Props.error;
  var classNameOpt = Props.className;
  var requirement_labels = Props.requirement_labels;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement("div", {
              className: "" + styles["requirement-container"] + " " + className + ""
            }, React.createElement("div", {
                  className: styles["input-container"]
                }, React.createElement("label", {
                      className: "" + (
                        is_required ? styles["label-required"] : styles.label
                      ) + " \n            " + (
                        Belt_Option.isSome(error) ? styles.error : ""
                      ) + "",
                      htmlFor: label
                    }, label), React.createElement(FareEstimateReqRadioGroupCmp$PorterinFeature.make, {
                      requirement: requirement,
                      onChange: onChange,
                      disabled: disabled,
                      requirement_labels: requirement_labels
                    })), error !== undefined ? React.createElement("div", {
                    className: styles["error-container"]
                  }, error) : null);
}

var make = FareEstimateSelectReqCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
